import { render, staticRenderFns } from "./IpadBuyNow.vue?vue&type=template&id=77f50d3b&"
import script from "./IpadBuyNow.vue?vue&type=script&lang=js&"
export * from "./IpadBuyNow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports